import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { VueSlideToggle } from "vue-slide-toggle";
import orderItem from "../order-item/index.vue";

export default {
    props: ["item"],
    name: "active-orders",
    data() {
        return {
            openitemInfo: false,
        };
    },
    components: {
        VueSlideToggle,
        orderItem,
    },
    computed: {
        ...mapGetters({
            activeOrderListLength: "profile/activeOrderListLength",
            user: "profile/user",
        }),

        totalBonuses() {
            return this.item.products.reduce((accumulator, currentValue) => {
                let bonuses = currentValue.price - currentValue.min_price;
                let percentOfBonuses = (bonuses * 19.5) / 100;

                bonuses = currentValue.bonuses
                    ? parseFloat(currentValue.bonuses)
                    : (bonuses - percentOfBonuses) * currentValue.select_count;
                let allBonuses = bonuses + accumulator;

                return allBonuses;
            }, 0);
        },
        totalAmount() {
            return this.item.products.reduce((accumulator, currentValue) => {
                return (
                    accumulator +
                    (currentValue.discount_price ? currentValue.discount_price : currentValue.select_price) *
                        currentValue.select_count
                );
            }, 0);
        },
    },
    created() {
        // this.fetchActiveOrderList();
        // this.fetchUserData();
        // console.log(this.item);
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            fetchActiveOrderList: `profile/GET_ACTIVE_ORDER_LIST`,
            removeOrder: `profile/DELETE_ORDER`,
        }),
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        deleteOrder() {
            this.removeOrder(this.item.id).then(() => {
                this.$toasted.success(this.$t("successCancelOrder"));
                this.fetchActiveOrderList();
            });
        },
    },
};
